import { OSDefaultLight } from '#web-components/styles';

export const drawColors = [
  { value: OSDefaultLight.colors.uIBlueBase, label: 'blue' },
  { value: OSDefaultLight.colors.uIGreenBase, label: 'green' },
  { value: OSDefaultLight.colors.uIYellowBase, label: 'yellow' },
  { value: OSDefaultLight.colors.uIRedBase, label: 'red' },
];
